import { CommunicationIcon } from 'foundations-assets/icons/components/CommunicationIcon';
import { ConditionalIcon } from 'foundations-assets/icons/components/ConditionalIcon';
import { CrmIcon } from 'foundations-assets/icons/components/CrmIcon';
import { MarketingIcon } from 'foundations-assets/icons/components/MarketingIcon';
import { ProductBundleIcon } from 'foundations-assets/icons/components/ProductBundleIcon';
export const MAX_VISIBLE_ICONS = 3;
// Category-based icon and color pairs for workflow action types.
// Mirrors CATEGORY_ICON_MAP / CATEGORY_COLOR_MAP in
// automation-studio-intro-ui-lib/components/create-workflow/TemplateIconsList.tsx
export const ACTION_TYPE_ICON_MAP = {
  // COMMUNICATIONS
  CLASSIC_NOTIFICATION_EMAIL: {
    icon: CommunicationIcon,
    iconColor: 'fill-accent-purple-default',
    backgroundColor: 'fill-accent-purple-subtle-alt'
  },
  EMAIL: {
    icon: CommunicationIcon,
    iconColor: 'fill-accent-purple-default',
    backgroundColor: 'fill-accent-purple-subtle-alt'
  },
  EMAIL_NOTIFICATION: {
    icon: CommunicationIcon,
    iconColor: 'fill-accent-purple-default',
    backgroundColor: 'fill-accent-purple-subtle-alt'
  },
  IN_APP_NOTIFICATION: {
    icon: CommunicationIcon,
    iconColor: 'fill-accent-purple-default',
    backgroundColor: 'fill-accent-purple-subtle-alt'
  },
  SEND_SMS_NOTIFICATION: {
    icon: CommunicationIcon,
    iconColor: 'fill-accent-purple-default',
    backgroundColor: 'fill-accent-purple-subtle-alt'
  },
  SLACK_NOTIFICATION: {
    icon: CommunicationIcon,
    iconColor: 'fill-accent-purple-default',
    backgroundColor: 'fill-accent-purple-subtle-alt'
  },
  // CRM
  CLASSIC_COPY_COMPANY_PROPERTY: {
    icon: CrmIcon,
    iconColor: 'fill-accent-green-default',
    backgroundColor: 'fill-accent-green-subtle-alt'
  },
  CREATE_OBJECT: {
    icon: CrmIcon,
    iconColor: 'fill-accent-green-default',
    backgroundColor: 'fill-accent-green-subtle-alt'
  },
  CREATE_SALESFORCE_CAMPAIGN: {
    icon: CrmIcon,
    iconColor: 'fill-accent-green-default',
    backgroundColor: 'fill-accent-green-subtle-alt'
  },
  CREATE_SALESFORCE_TASK: {
    icon: CrmIcon,
    iconColor: 'fill-accent-green-default',
    backgroundColor: 'fill-accent-green-subtle-alt'
  },
  INCREASE_PROPERTY: {
    icon: CrmIcon,
    iconColor: 'fill-accent-green-default',
    backgroundColor: 'fill-accent-green-subtle-alt'
  },
  ROTATE_OBJECT: {
    icon: CrmIcon,
    iconColor: 'fill-accent-green-default',
    backgroundColor: 'fill-accent-green-subtle-alt'
  },
  SET_PROPERTY: {
    icon: CrmIcon,
    iconColor: 'fill-accent-green-default',
    backgroundColor: 'fill-accent-green-subtle-alt'
  },
  TASK: {
    icon: CrmIcon,
    iconColor: 'fill-accent-green-default',
    backgroundColor: 'fill-accent-green-subtle-alt'
  },
  // DATA_OPS
  CUSTOM_CODE: {
    icon: ProductBundleIcon,
    iconColor: 'fill-accent-yellow-default',
    backgroundColor: 'fill-accent-yellow-subtle-alt'
  },
  EXTENSION: {
    icon: ProductBundleIcon,
    iconColor: 'fill-accent-yellow-default',
    backgroundColor: 'fill-accent-yellow-subtle-alt'
  },
  FORMULA: {
    icon: ProductBundleIcon,
    iconColor: 'fill-accent-yellow-default',
    backgroundColor: 'fill-accent-yellow-subtle-alt'
  },
  WEBHOOK: {
    icon: ProductBundleIcon,
    iconColor: 'fill-accent-yellow-default',
    backgroundColor: 'fill-accent-yellow-subtle-alt'
  },
  // MARKETING
  ADS_AUDIENCE_MEMBERSHIP: {
    icon: MarketingIcon,
    iconColor: 'fill-accent-light-orange-default',
    backgroundColor: 'fill-accent-light-orange-subtle-alt'
  },
  ALTER_LIST_MEMBERSHIP: {
    icon: MarketingIcon,
    iconColor: 'fill-accent-light-orange-default',
    backgroundColor: 'fill-accent-light-orange-subtle-alt'
  },
  CLASSIC_ALTER_LIST_MEMBERSHIP: {
    icon: MarketingIcon,
    iconColor: 'fill-accent-light-orange-default',
    backgroundColor: 'fill-accent-light-orange-subtle-alt'
  },
  UPDATE_EMAIL_SUBSCRIPTION: {
    icon: MarketingIcon,
    iconColor: 'fill-accent-light-orange-default',
    backgroundColor: 'fill-accent-light-orange-subtle-alt'
  },
  // QUICK_ACTIONS
  AB_TEST_BRANCH: {
    icon: ConditionalIcon,
    iconColor: 'fill-accent-neutral-default',
    backgroundColor: 'fill-accent-neutral-subtle-alt'
  },
  ALL_BRANCHES: {
    icon: ConditionalIcon,
    iconColor: 'fill-accent-neutral-default',
    backgroundColor: 'fill-accent-neutral-subtle-alt'
  },
  ALL_DELAYS: {
    icon: ConditionalIcon,
    iconColor: 'fill-accent-neutral-default',
    backgroundColor: 'fill-accent-neutral-subtle-alt'
  },
  CLASSIC_ANCHORED_DELAY: {
    icon: ConditionalIcon,
    iconColor: 'fill-accent-neutral-default',
    backgroundColor: 'fill-accent-neutral-subtle-alt'
  },
  CLASSIC_ENROLL_IN_WORKFLOW: {
    icon: ConditionalIcon,
    iconColor: 'fill-accent-neutral-default',
    backgroundColor: 'fill-accent-neutral-subtle-alt'
  },
  CLASSIC_VIRTUAL_ANCHORED_DELAY: {
    icon: ConditionalIcon,
    iconColor: 'fill-accent-neutral-default',
    backgroundColor: 'fill-accent-neutral-subtle-alt'
  },
  CRITERIA_BRANCH: {
    icon: ConditionalIcon,
    iconColor: 'fill-accent-neutral-default',
    backgroundColor: 'fill-accent-neutral-subtle-alt'
  },
  DELAY: {
    icon: ConditionalIcon,
    iconColor: 'fill-accent-neutral-default',
    backgroundColor: 'fill-accent-neutral-subtle-alt'
  },
  DELAY_UNTIL_DATE: {
    icon: ConditionalIcon,
    iconColor: 'fill-accent-neutral-default',
    backgroundColor: 'fill-accent-neutral-subtle-alt'
  },
  ENROLL_IN_FLOW: {
    icon: ConditionalIcon,
    iconColor: 'fill-accent-neutral-default',
    backgroundColor: 'fill-accent-neutral-subtle-alt'
  },
  GO_TO: {
    icon: ConditionalIcon,
    iconColor: 'fill-accent-neutral-default',
    backgroundColor: 'fill-accent-neutral-subtle-alt'
  },
  LIST_BRANCH: {
    icon: ConditionalIcon,
    iconColor: 'fill-accent-neutral-default',
    backgroundColor: 'fill-accent-neutral-subtle-alt'
  },
  STATIC_BRANCH: {
    icon: ConditionalIcon,
    iconColor: 'fill-accent-neutral-default',
    backgroundColor: 'fill-accent-neutral-subtle-alt'
  },
  VIRTUAL_SCHEDULED_ENROLLMENT: {
    icon: ConditionalIcon,
    iconColor: 'fill-accent-neutral-default',
    backgroundColor: 'fill-accent-neutral-subtle-alt'
  },
  WAIT_UNTIL: {
    icon: ConditionalIcon,
    iconColor: 'fill-accent-neutral-default',
    backgroundColor: 'fill-accent-neutral-subtle-alt'
  },
  WHILE_LOOP: {
    icon: ConditionalIcon,
    iconColor: 'fill-accent-neutral-default',
    backgroundColor: 'fill-accent-neutral-subtle-alt'
  }
};